export default {
  ANNOUNCEMENT: 'Announcement',
  ACT: 'Act',
  CERTIFICATION: 'Certification',
};
